import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Container, Typography } from '@material-ui/core';
import Page from 'src/components/Page';

// Shown by detail pages whose record does not exist (ISSUE-0269).
const NotFoundCard = ({ title, message, backLabel, onBack }) => (
  <Page title={title}>
    <Container maxWidth="md">
      <Box py={6} textAlign="center">
        <Typography color="textSecondary" gutterBottom>
          {message}
        </Typography>
        <Button color="primary" onClick={onBack}>
          {backLabel}
        </Button>
      </Box>
    </Container>
  </Page>
);

NotFoundCard.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  backLabel: PropTypes.string.isRequired,
  onBack: PropTypes.func.isRequired
};

export default NotFoundCard;
